import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { ProductComponent } from './product/product.component';
import { ProductlistComponent } from './productlist/productlist.component';
import { ProductfilterComponent } from './productfilter/productfilter.component';
import { HomeComponent } from './home/home.component';

import { RouterModule, Routes } from '@angular/router';
import { ContentfulService } from './contentful.service';
import { AllProductsComponent } from './all-products/all-products.component';
import { HeaderComponent } from './header/header.component';
import { AddYourProductComponent } from './add-your-product/add-your-product.component';
import { FooterComponent } from './footer/footer.component';
import { ModalItemComponent } from './add-your-product/modal-item/modal-item.component';
import { ProductModalComponent } from './product-modal/product-modal.component';
import { ContactusComponent } from './contactus/contactus.component';
import { AboutusComponent } from './aboutus/aboutus.component';



const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'product', children:
    [
      {path: 'list', component: ProductlistComponent, children: [
        {
          path: ':category', component: ProductComponent
        }
      ]}
    ]
  },
  {
    path: 'contactus',
    component: ContactusComponent
  },
  {
    path: 'about',
    component: AboutusComponent
  },
  {
    path: '',
    redirectTo: '/product/list/everything',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/product/list/everything',
    pathMatch: 'full'
  },


];

@NgModule({
  declarations: [
    AppComponent,
    ProductComponent,
    ProductlistComponent,
    ProductfilterComponent,
    HomeComponent,
    AllProductsComponent,
    HeaderComponent,
    AddYourProductComponent,
    FooterComponent,
    ModalItemComponent,
    ProductModalComponent,
    ContactusComponent,
    AboutusComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes),

  ],
  providers: [ContentfulService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/app.module.ts